module.exports = __webpack_public_path__ + "static/media/brand_botanical.5eac0d07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brand_botanical.png
// module id = 68
// module chunks = 0